import Image from "./Image";

export {
    Image as default,
};
